<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import "assets/css/reset.scss";
@import "assets/css/style.scss";
@import "assets/fonts/iconfont.css";
@import "assets/fonts/font-awesome.css";

body{
	width:100%;
	height:100%;

}
#app {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  background:rgba(240,243,246,1);
}
.el-badge__content{

}

</style>



// WEBPACK FOOTER //
// src/App.vue